<template>
    <div class="container">
        请在移动端访问
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    created () {
       
    },
    methods: {
        
    },
}
</script>

<style lang="less" scoped>

</style>
